var _rect, _rect2, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 640,
    viewBox: "0 0 1440 640",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2115_8368)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 640,
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2115_8368",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1440,
    height: 640
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 640,
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2115_8368)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2115_8368",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1440,
    height: 640
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H1440C1440 0 1440 628.196 1440 640H0V0Z",
    fill: "url(#paint0_linear_2115_8368)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2115_8368)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.19 -14.0311C173.028 78.0855 183.318 256.663 329.767 234.037C476.215 211.412 564.276 47.9186 590 -31",
    stroke: "#1D1D1D",
    strokeWidth: 2.42017
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.974 -66.8573C194.49 20.7742 204.25 190.656 343.161 169.133C482.072 147.609 565.6 -7.92383 590 -83",
    stroke: "#1D1D1D",
    strokeWidth: 2.42017
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-18 270C110.023 301.269 333.265 423.045 202.052 660",
    stroke: "#1D1D1D",
    strokeWidth: 2.42017
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11.0195 325.677C89.7154 364.46 256.839 486.993 119.453 666.864",
    stroke: "#1D1D1D",
    strokeWidth: 2.42017
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950.338 -15C939.969 21.1676 985.285 128.735 1249.49 269.665C1513.7 410.596 1526.08 607.276 1499.24 688",
    stroke: "#1D1D1D",
    strokeWidth: 2.42017
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1062.34 -40C1051.97 -3.83236 1097.28 103.735 1361.49 244.665C1625.7 385.596 1638.08 582.276 1611.24 663",
    stroke: "#1D1D1D",
    strokeWidth: 2.42017
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1127.34 -81C1116.97 -44.7809 1162.28 62.9399 1426.49 204.07C1690.7 345.201 1703.08 542.161 1676.24 623",
    stroke: "#1D1D1D",
    strokeWidth: 2.42017
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1208.34 -109C1197.97 -72.8324 1243.28 34.7354 1507.49 175.665C1771.7 316.596 1784.08 513.276 1757.24 594",
    stroke: "#1D1D1D",
    strokeWidth: 2.42017
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2115_8368",
    x1: -152.089,
    y1: 267.563,
    x2: 1635.9,
    y2: 267.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#702EFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2115_8368"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 640,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanner);
export default __webpack_public_path__ + "static/media/banner.ca23afa30e6a59d6092dceb76241d4db.svg";
export { ForwardRef as ReactComponent };